import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from './Spinner.scss'

const Spinner = (props) => {
  return <span className={cx(classes.spinner, props.className)} />
}

Spinner.propTypes = {
  className: PropTypes.string
}

Spinner.defaultProps = {}

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js